<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <core-table
          :title="config.title"
          upsert-max-width="850px"
          :config="config"
          @filters="setFilters"
          ref="protocolSiteTable">

        <template slot='headerActions'>
            <slot name='headerActions'/>
              

               <v-badge
                v-if="$can('upsert', 'protocol_has_site')"
                style="margin-right:30px"
                color="pink"
                :content="counters['SafetyDB']"
                overlap
              >
                <v-chip @click="sync('SafetyDB')">SafetyDB</v-chip>
              </v-badge>

              <v-badge
                v-if="$can('upsert', 'protocol_has_site')"
                style="margin-right:30px"
                color="pink"
                :content="counters['eCDS']"
                overlap
              >
                <v-chip @click="sync('eCDS')">eCDS</v-chip>
              </v-badge>

              <v-badge :loading="true"
                v-if="$can('upsert', 'protocol_has_site')"
                style="margin-right:40px"
                color="pink"
                :content="counters['eTMF']"
                overlap
              >
                <v-chip :loading="true" @click="sync('eTMFlex')">eTMFlex</v-chip>
              </v-badge>
           
            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">
                <v-btn
                  v-on="on"
                  v-if="$can('import', 'protocol_has_site')"
                  color="secondary"
                  @click="import_csv_modal = true">
                  <v-icon>mdi-upload</v-icon>
                </v-btn>
              </template>
              <span>Import CSV</span>
            </v-tooltip>


            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">
                <v-btn
                  v-on="on"
                  :loading="loadingExport['excel']"
                  v-if="$can('export', 'protocol_has_site')"
                  color="secondary"
                  @click="export_excel()">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Export Excel</span>
            </v-tooltip>

            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">
                 <v-btn
                  v-on="on"
                  :loading="loadingExport['csv']"
                  v-if="$can('export', 'protocol_has_site')"
                  color="secondary"
                  @click="export_csv()">
                  <v-icon>mdi-file-delimited</v-icon>
                </v-btn>
              </template>
              <span>Export CSV</span>
            </v-tooltip>

        </template>

        </core-table>

        <app-import-protocol-site-modal v-model="import_csv_modal" @imported="updateList"/>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import {export_data} from '@/api/export.js'
import { post, get } from '@/api/base_entity'

export default {
  data () {
    return {
      config,
      protocol_id: null,
      site_id: null,
      loadingExport: {'csv':false, 'excel':false},
      import_csv_modal: false,
      counters: {},
      filters: {}
    }
  },
  async created () {
  },
  mounted() {
    this.loadCounters()
  },
  methods: {
    async sync(platform) {

      const ret = await this.$root.$confirm.open('Confirm Sync Platform', 'Are you sure you want to sync the prococol sites for platform '  + platform + ' ?', { color: 'red' })
      if (!ret) {
        return
      }

      this.counters[platform] = '...'

      post('/sync_platforms/protocol_site', {platform}).then( () => {
         this.$root.$emit('openSnackbar', {
          message: platform + ' synced correctly',
          color: 'success'
        })
      }).finally( () => {
        this.loadCounters()
      })

    },
    loadCounters() {
      let filters = {}
      if(this.filters['protocol_id'] && this.filters['protocol_id'][0]['protocol.name']) {
        filters['protocol.name'] = this.filters['protocol_id'][0]['protocol.name']
      }
      get('/protocol_site_counters', {'x-filters' : JSON.stringify(filters)}).then( ret => {
        this.counters = ret
      })
    },
    export_csv() {
      this.loadingExport['csv'] = true
      export_data('protocol_has_site').then( () => {
        this.loadingExport['csv'] = false
      })
    },
    export_excel() {
      this.loadingExport['excel'] = true
      export_data('protocol_has_site', 'excel').then( () => {
        this.loadingExport['excel'] = false
      })
    },
    updateList() {
      this.$refs.protocolSiteTable.getData()
      this.import_csv_modal = false
    },
    setFilters(filters) {
      this.filters = filters
      this.loadCounters()
    }
  }
}
</script>
